const clientEmailTemplate = (clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers) => {
  return `
    <p>
      Dear <span id="clientNames">CLIENT_NAMES</span>
    </p>

    <p>
      I am pleased to confirm the consultation call scheduled with ${expertInfo}. <span id="additional-text" contenteditable="false">{{{additionalText}}}</span>
    </p>

    {{{generateZoomInfo}}}

    <p>
      You should be connected to our Expert within a few minutes, please do hold the line.
    </p>

    <p>
      In case of any queries, please do not hesitate to contact me
      via email or via phone.
    </p>

    <p>
      Please accept this invitation before the time of consultation.
    </p>

    {{{callRecordedText}}}
    
    <div id="expert-pdf" contenteditable="false">{{{expertPdfAttachment}}}</div>

    <div id="screening" contenteditable="false">{{{screeningQuestions}}}</div>

    <p id="signature">
      ${availabilityStore.userStore.user.fullName}<br>
      ${userPosition}<br>
      ${availabilityStore.userStore.user.email}<br>
      ${userPhoneNumbers.join('<br>')}<br>
      <a href="www.atheneum-partners.com">www.atheneum-partners.com</a>
    </p>
   `;
};

export default clientEmailTemplate;